import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Col, Row } from 'components/ui';

import UploadField from 'containers/Mail/FormFields/UploadField';
import { useValidateExperimentationCsv } from '../../../query/ab-test';

const UploadRecipients = ({ setIsCsvValid, setTotalRows }) => {
  const { watch } = useFormContext();
  const featureName = watch('growthBookFeatureName');
  const files = watch('csvFiles');
  const { data, isFetching } = useValidateExperimentationCsv(
    files[0],
    featureName,
  );
  useEffect(() => {
    setIsCsvValid && setIsCsvValid(data?.valid);
    setTotalRows && setTotalRows(data?.totalRows || 0);
  }, [data]);

  return (
    <Row>
      <Col span={22} style={{ marginBottom: 10 }}>
        <UploadField
          data={data}
          disabled={!featureName}
          isFetching={isFetching}
        />
      </Col>
    </Row>
  );
};

export default UploadRecipients;
